import React from 'react';
import { Button, Typography } from '@mui/material';
import { Delete } from '@mui/icons-material';
import StandardDialog, { StandardDialogActions } from '../../../Modals/StandardDialog';

type DeleteAssessmentDialogProps = {
  isOpen: boolean;
  handleClose: () => void;
  onConfirm: () => void;
  disabled?: boolean;
};

const DeleteAssessmentDialog = ({ isOpen, handleClose, onConfirm, disabled }: DeleteAssessmentDialogProps) => (
  <StandardDialog
    title={'Delete Assessment?'}
    handleClose={handleClose}
    isOpen={isOpen}
  >
    <Typography>Are you sure you want to delete this assessment? Please notify the assessor after deleting.</Typography>
    <StandardDialogActions>
      <Button variant='outlined' onClick={handleClose}>Cancel</Button>
      <Button
        variant='outlined'
        color='error'
        startIcon={<Delete />}
        onClick={onConfirm}
        disabled={disabled}
      >
        Delete
      </Button>
    </StandardDialogActions>
  </StandardDialog>
);

export default DeleteAssessmentDialog;
